var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncDashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4126_59082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1071 23.2344C24.6003 23.2344 25 23.6296 25 24.1171C25 24.6047 24.6003 24.9999 24.1071 24.9999H0.892857C0.399746 24.9999 0 24.6047 0 24.1171C0 23.6296 0.399746 23.2344 0.892857 23.2344H24.1071Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 24.116V1.16402C0 0.676479 0.399746 0.28125 0.892857 0.28125C1.38597 0.28125 1.78571 0.676479 1.78571 1.16402V24.116C1.78571 24.6035 1.38597 24.9988 0.892857 24.9988C0.399746 24.9988 0 24.6035 0 24.116Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.82059 21.4679C5.32773 21.4679 4.92773 21.0724 4.92773 20.5851V4.69527C4.92773 4.20798 5.32773 3.8125 5.82059 3.8125C6.31345 3.8125 6.71345 4.20798 6.71345 4.69527V20.5851C6.71345 21.0724 6.31345 21.4679 5.82059 21.4679Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5349 17.0892C16.2456 17.0892 15.9599 17.0751 15.6777 17.0469V20.585C15.6777 21.0723 16.0777 21.4678 16.5706 21.4678C17.0634 21.4678 17.4634 21.0723 17.4634 20.585V17.0645C17.1599 17.0928 16.8492 17.0998 16.5349 17.0892Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0294 15.885L10.3223 14.582V20.5884C10.3223 21.0757 10.7223 21.4712 11.2151 21.4712C11.708 21.4712 12.108 21.0757 12.108 20.5884V15.9309C12.083 15.9168 12.0544 15.9027 12.0294 15.8885V15.885Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9277 15.7328C14.8242 15.7328 12.8456 14.9171 11.3599 13.4305C9.87416 11.9475 9.05273 9.97363 9.05273 7.87617C9.05273 5.77871 9.87059 3.80484 11.3599 2.32179C12.8456 0.83874 14.8242 0.0195312 16.9277 0.0195312C19.0313 0.0195312 21.0099 0.835209 22.4956 2.32179C23.9813 3.80484 24.8027 5.77871 24.8027 7.87617C24.8027 9.97363 23.9849 11.9475 22.4956 13.4305C21.0099 14.9136 19.0313 15.7328 16.9277 15.7328ZM16.9277 1.22716C13.2527 1.22716 10.2634 4.21092 10.2634 7.87617C10.2634 11.5414 13.2527 14.5252 16.9277 14.5252C20.6027 14.5252 23.592 11.5414 23.592 7.87617C23.592 4.21092 20.6027 1.22716 16.9277 1.22716ZM16.9277 12.5089C16.592 12.5089 16.3206 12.237 16.3206 11.9051V11.8981C16.3206 11.5626 16.592 11.2942 16.9277 11.2942C17.2634 11.2942 17.5349 11.5661 17.5349 11.8981V11.9051C17.5349 12.2406 17.2634 12.5089 16.9277 12.5089ZM16.9277 10.0937C16.592 10.0937 16.3206 9.82179 16.3206 9.48987V3.85075C16.3206 3.51529 16.592 3.24693 16.9277 3.24693C17.2634 3.24693 17.5349 3.51883 17.5349 3.85075V9.48987C17.5349 9.82532 17.2634 10.0937 16.9277 10.0937Z",
    fill: "#3D3C42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4126_59082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncDashIcon);
export default __webpack_public_path__ + "static/media/inc_dash-icon.65af05691decf478935f64aae9e080a4.svg";
export { ForwardRef as ReactComponent };